"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GracefulStore = exports.initialProps = exports.initialContextProps = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
exports.initialContextProps = {
    ctx: {
        headers: {},
        url: '',
        isError: false,
        status: 404,
        responseBody: null,
        typeOfRequest: 'FETCH',
        method: '',
        retriesLeft: 0,
        requestBody: null,
    },
};
exports.initialProps = __assign(__assign({}, exports.initialContextProps), { errorInfo: new Map(), setGraceful: lodash_1.noop });
exports.GracefulStore = (0, react_1.createContext)(exports.initialProps);
